import { render } from "./issueAction.vue?vue&type=template&id=0eeef17f&scoped=true"
import script from "./issueAction.vue?vue&type=script&lang=js"
export * from "./issueAction.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0eeef17f"

export default script